import common from "../../../utils/common";
import { EventImpl } from "@fullcalendar/core/internal";
import moment from "moment";

const isHolidayEvent = (event: EventImpl) => {
  return event?.extendedProps?.tag === "holiday";
};
const isHolidayByDate = (date: Date, eventArray: EventImpl[]) => {
  if (!eventArray || eventArray.length === 0) {
    return false;
  }
  return eventArray.find(
    (x) =>
      x.extendedProps.tag != null &&
      x.extendedProps.tag === "holiday" &&
      calendarEntryDateCompare(x, date),
  );
};

const calendarEntryDateCompare = (entry: EventImpl, date: Date) => {
  if (!entry || !entry.extendedProps.startDate || !date) {
    return false;
  }

  let startDate = "";
  if (entry.extendedProps.startDate instanceof Date) {
    startDate = entry.extendedProps.startDate.toLocaleDateString("en-CA");
  } else {
    const dateVal = common.dateStringToDate(entry.extendedProps.startDate);
    if (dateVal) {
      startDate = (dateVal as Date).toLocaleDateString("en-CA");
    }
  }
  return startDate === date.toLocaleDateString("en-CA");
};

const getHolidayInDateRange = (
  start: string | Date,
  end: string | Date,
  eventArray: EventImpl[],
) => {
  if (!eventArray || eventArray.length === 0) {
    return false;
  }
  return eventArray.filter(
    (x) =>
      x.extendedProps?.startDate !== undefined &&
      x.extendedProps?.endDate !== undefined &&
      moment(x.extendedProps.startDate).isValid() &&
      moment(x.extendedProps.endDate).isValid() &&
      moment(x.extendedProps.startDate) >= moment(start) &&
      moment(x.extendedProps.endDate) <= moment(end) &&
      x.extendedProps.tag != null &&
      x.extendedProps.tag === "holiday",
  );
};

const getDateRangeString = (date1: Date, date2: Date) => {
  if (!moment(date1).isValid() || !moment(date2).isValid()) {
    return "";
  }
  const startDate = moment(date1).format("DD/MMM/YYYY HH:mm");
  const endDate = moment(date2).format("DD/MMM/YYYY HH:mm");
  return `${startDate} - ${endDate}`;
};

const getTimeTextString = (date1: Date | string, date2: Date | string) => {
  if (!moment(date1).isValid() || !moment(date2).isValid()) {
    return "";
  }
  const startDate = moment(date1).format("HH");
  const endDate = moment(date2).format("HH");
  return `${startDate}-${endDate}`;
};

const transformEventTitleText = (
  timeText: string,
  sfx: string,
  titleText: string,
) => {
  const textLimit = 24;
  const combined = `${timeText}${sfx}${titleText}`;
  if (combined.length > textLimit) {
    const diff = combined.length - textLimit;
    return `${titleText.substring(0, titleText.length - diff)}`;
  } else {
    return titleText;
  }
};

const CalendarUtil = {
  isHolidayByDate,
  isHolidayEvent,
  calendarEntryDateCompare,
  getHolidayInDateRange,
  getDateRangeString,
  getTimeTextString,
  transformEventTitleText,
};
export default CalendarUtil;
